import { environment } from '../../../environments/environment';

export interface MarketplaceAuthConfig {
  authUrl: string;
  tokenUrl: string;
  endSessionUrl: string;
  /** SPA client ID */
  clientId: string;
  /** Marketplace backend service client ID — included in scope to expand id_token aud */
  serviceClientId: string;
}

export const MARKETPLACE_AUTH_CONFIG: MarketplaceAuthConfig = {
  authUrl:       `${environment.auth.csiBaseUrl}/v2/auth`,
  tokenUrl:      `${environment.auth.csiBaseUrl}/v2/token`,
  endSessionUrl: `${environment.auth.csiBaseUrl}/v2/slo`,
  clientId:        environment.auth.clientId,
  serviceClientId: environment.auth.serviceClientId,
};
